import React from "react";

export const Title: React.FC<{ title: string }> = ({ title }) => {
  React.useEffect(() => {
    document.title = title + " | Wassermenschen";
  }, [title]);
  return <></>;
};
